<template>
  <user-listing :durationFilter="true" :exportCSV="true"></user-listing>
</template>
<script>
import { pickSvg } from "@/views/SVG";
import UserListing from "../userListing/userListing.vue";
export default {
  components: {
    UserListing,
    ...pickSvg("verticalDotsSVG", "nonverifiedUserSVG", "verifiedUserSVG"),
  },
};
</script>